import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import affiliateApiClient, { setAffiliateSession } from '../lib/affiliateApiClient';

export default function AffiliateLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      const { data } = await affiliateApiClient.post('/login', { email: email.trim(), password });
      setAffiliateSession(data.sessionToken);
      navigate('/affiliate/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <form onSubmit={submit} className="max-w-md w-full bg-white rounded-2xl border border-gray-200 p-8 shadow-sm space-y-4">
        <h1 className="text-2xl font-bold text-gray-900 text-center">Affiliate login</h1>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="w-full px-4 py-3 border border-gray-300 rounded-lg text-sm" />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Password</label>
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="w-full px-4 py-3 border border-gray-300 rounded-lg text-sm" />
        </div>
        {error && <p className="text-sm text-red-600">{error}</p>}
        <button disabled={submitting} className="w-full py-3 bg-indigo-600 text-white rounded-lg font-medium hover:bg-indigo-700 disabled:opacity-50">
          {submitting ? 'Logging in...' : 'Log in'}
        </button>
        <p className="text-center text-sm text-gray-500">
          <Link to="/affiliate/forgot-password" className="text-indigo-600 hover:underline">Forgot your password?</Link>
        </p>
      </form>
    </div>
  );
}
